import { Pipe, PipeTransform } from '@angular/core';
import { LIST_MEASURE_UNIT, MeasureUnitEnum } from '../../models/vehicle.model';

type measureType = 'weight' | 'length' | 'volume' | 'surface';

@Pipe({
  name: 'measureUnit',
  standalone: true,
})
export class MeasureUnitPipe implements PipeTransform {
  transform(value: number, type: measureType, forceBaseUnit?: boolean): string {
    switch (type) {
      case 'weight': {
        if (value >= 1000 && !forceBaseUnit) {
          return `${(value / 1000).toFixed(value % 1000 ? 2 : 0)} ${LIST_MEASURE_UNIT[MeasureUnitEnum.TONNE].label}`;
        }
        return `${value.toFixed(value - Math.floor(value) ? 2 : 0)} ${LIST_MEASURE_UNIT[MeasureUnitEnum.KG].label}`;
      }
      case 'length': {
        if (value >= 100 && !forceBaseUnit) {
          return `${(value / 100).toFixed(value % 100 ? 2 : 0)} ${LIST_MEASURE_UNIT[MeasureUnitEnum.METER].label}`;
        }
        return `${value.toFixed(value - Math.floor(value) ? 2 : 0)} ${LIST_MEASURE_UNIT[MeasureUnitEnum.CENTIMETER].label}`;
      }
      case 'volume': {
        return `${value.toFixed(value - Math.floor(value) ? 2 : 0)} ${LIST_MEASURE_UNIT[MeasureUnitEnum.CUBIC_METER].label}`;
      }
      case 'surface': {
        return `${value.toFixed(value - Math.floor(value) ? 2 : 0)} ${LIST_MEASURE_UNIT[MeasureUnitEnum.SQUARE_METER].label}`;
      }
      default: {
        throw new Error(`${value} is not a measure unit`);
      }
    }
  }
}
